import React from 'react';

export interface SignOutModalProps {
    onClose: () => void;
    onSignOut: () => void;
}

const SignOutModal: React.FC<SignOutModalProps> = ({ onClose, onSignOut }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-6 rounded shadow-lg">
                <h2 className="text-lg font-semibold mb-4 ">Sign Out</h2>
                <p className="mb-4">Are you sure you want to sign out?</p>
                <div className="flex justify-end">
                    <button
                        data-testid="signout-modal-cancel-button"
                        className="bg-gray-500 text-white px-[1rem] py-[0.5rem] rounded mr-6"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        data-testid="signout-modal-sign-out-button"
                        className="bg-red-500 text-white px-[1rem] py-[0.5rem] rounded mr-6"
                        onClick={onSignOut}
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignOutModal;
